import React from "react";

const ColorRamp = (props) => {

    return <div style={{
        background: `linear-gradient(to right, ${props.colorRamp.join(',')})`
    }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
}

export default ColorRamp;